module.exports = __webpack_public_path__ + "static/media/productCategory-08.29f0bc91.png";